import { documentLogin } from './documentLogin';
import { login } from './login';
import { passwordRecovery } from './passwordRecovery';
import { signup } from './signup';
import { updatePassword } from './updatePassword';

const pt = {
  ...documentLogin,
  ...login,
  ...passwordRecovery,
  ...signup,
  ...updatePassword,
};

export default pt;
